/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateCustomerVaultRequest
 */
export interface CreateCustomerVaultRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerVaultRequest
     */
    tokenId: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateCustomerVaultRequest
     */
    transactionId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCustomerVaultRequest
     */
    isDefault: boolean;
}

/**
 * Check if a given object implements the CreateCustomerVaultRequest interface.
 */
export function instanceOfCreateCustomerVaultRequest(value: object): value is CreateCustomerVaultRequest {
    if (!('tokenId' in value) || value['tokenId'] === undefined) return false;
    if (!('transactionId' in value) || value['transactionId'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    return true;
}

export function CreateCustomerVaultRequestFromJSON(json: any): CreateCustomerVaultRequest {
    return CreateCustomerVaultRequestFromJSONTyped(json, false);
}

export function CreateCustomerVaultRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCustomerVaultRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tokenId': json['tokenId'],
        'transactionId': ApiUserTasksGetPageParameterFromJSON(json['transactionId']),
        'isDefault': json['isDefault'],
    };
}

export function CreateCustomerVaultRequestToJSON(json: any): CreateCustomerVaultRequest {
    return CreateCustomerVaultRequestToJSONTyped(json, false);
}

export function CreateCustomerVaultRequestToJSONTyped(value?: CreateCustomerVaultRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tokenId': value['tokenId'],
        'transactionId': ApiUserTasksGetPageParameterToJSON(value['transactionId']),
        'isDefault': value['isDefault'],
    };
}

